import { Modal, ModalContent, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import { FC, useEffect } from 'react';

interface Props {
    isVisible: boolean;
}

const LoaderModal: FC<Props> = ({ isVisible }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        if (isVisible) {
            onOpen();
        } else {
            if (isOpen) {
                onClose();
            }
        }
    }, [isOpen, isVisible, onClose, onOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent
                background="transparent"
                boxShadow="none"
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                margin={0}
            >
                <span className="loader"></span>
            </ModalContent>
        </Modal>
    );
};

export default LoaderModal;
